import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import {
  AttachSchedulerRequest,
  LocationImport,
  Lookup,
  MasterPlan,
  OptimizePlanSignalR,
  Plan,
  PlanType,
  VehicleGroup,
  PostalCode,
  GetMasterPlansRequest,
  Product,
  Tag,
} from 'planning-portal-library/src/lib/core/domain';
import { BaseState } from '../../base/state/base.state';
import {
  GetPostalCodes,
  GetProducts,
  GetTags,
  SelectedMasterPlan,
  SetMasterPlans,
  SetMasterPlanRequest,
  SetMasterPlanPageRefreshFlag,
  GetPlanType,
  SetPlanId,
  SelectedPlan,
  SelectedDistributionLaneId,
  ClonePlan,
  GetPlanLookup,
  GetScheduler,
  SetSignalRResponseOPtimizePlan,
  GetMasterPlanLookup,
  SetIsPlanRevision,
  GetMasterLocations,
  GetSegmentIds,
  SetMasterPlanRoutePageRefreshFlag,
  SetMasterPlanLocationGroupPageRefreshFlag,
  setIsCommittedFlag
} from './master-plan.actions';
import { PlanDetails } from 'planning-portal-library/src/lib/core/domain/models/plan-details';
import { SelectedSegmentId } from 'planning-portal-library/src/lib/core/domain/models/private-location/selected-building-block-id';

export class MasterPlansStateModel {
  plans: Plan[] | undefined;
  masterPlans: MasterPlan[] | undefined;
  selectedMasterPlan: MasterPlan | undefined;
  vehicleGroups: VehicleGroup | undefined;
  products: Product[] | undefined;
  postalCode: PostalCode[] | undefined;
  tags: Tag[] | undefined;
  masterPlanRequest: GetMasterPlansRequest | undefined;
  refreshMasterPlanGrid: boolean | undefined;
  refreshRoutes: boolean | undefined;
  refreshLocationGroupInPlans:boolean|undefined;
  isPlanCommitted: boolean | undefined;
  planType: PlanType[] | undefined;
  planId: string | undefined;
  planDetails: PlanDetails[] | undefined;
  selectedPlan: Plan | undefined;
  distributionLaneId:string|undefined;
  isPlanCloned: boolean | undefined;
  plansLookup: Lookup[] | undefined;
  masterPlansLookup: Lookup[] | undefined;
  optimizePlanSignalR: OptimizePlanSignalR | undefined;
  scheduler: AttachSchedulerRequest | undefined;
  isPlanRevision: boolean | undefined;
  masterLocations: LocationImport[] | undefined;
  Segments: SelectedSegmentId[] | undefined;
}

const defaults = {
  isMasterPlanCreated: undefined,
  plans: undefined,
  masterPlans: undefined,
  selectedMasterPlan: undefined,
  vehicleGroups: undefined,
  products: undefined,
  postalCode: undefined,
  tags: undefined,
  locations: undefined,
  masterPlanRequest: undefined,
  refreshMasterPlanGrid: undefined,
  planType: undefined,
  planId: undefined,
  planDetails: undefined,
  selectedPlan: undefined,
  distributionLaneId:undefined,
  isPlanCloned: undefined,
  plansLookup: undefined,
  isPlanRevision: undefined,
  masterPlansLookup: undefined,
  scheduler: undefined,
  optimizePlanSignalR: undefined,
  planJobDetails: undefined,
  masterLocations: undefined,
  Segments:undefined,
  refreshRoutes: undefined,
  refreshLocationGroupInPlans:undefined,
  isPlanCommitted:undefined,
};

@State<MasterPlansStateModel>({
  name: 'masterPlans',
  defaults,
})
@Injectable()
export class MasterPlansState extends BaseState {
  constructor() {
    super();
  }

  @Action(SetMasterPlans)
  getPlans(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SetMasterPlans
  ) {
    ctx.setState({ ...ctx.getState(), masterPlans: payload });
  }

  @Action(GetProducts)
  getProducts(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: GetProducts
  ) {
    ctx.setState({ ...ctx.getState(), products: payload });
  }

  @Action(GetPostalCodes)
  getPostalCodes(ctx: StateContext<MasterPlansStateModel>, { payload }: GetPostalCodes) {
    ctx.setState({ ...ctx.getState(), postalCode: payload });
  }

  @Action(GetTags)
  getTags(ctx: StateContext<MasterPlansStateModel>, { payload }: GetTags) {
    ctx.setState({ ...ctx.getState(), tags: payload });
  }

  @Action(GetSegmentIds)
  getSegmentIds(ctx: StateContext<MasterPlansStateModel>, { payload }: GetSegmentIds) {
      ctx.setState({ ...ctx.getState(), Segments: payload });
  }


  @Action(SetMasterPlanRequest)
  setMasterPlanRequest(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SetMasterPlanRequest
  ) {
    ctx.setState({ ...ctx.getState(), masterPlanRequest: payload });
  }

  @Action(SelectedMasterPlan)
  selectedMasterPlan(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SelectedMasterPlan
  ) {
    if (payload) {
      return ctx.setState({ ...ctx.getState(), selectedMasterPlan: payload });
    } else {
      return ctx.setState({ ...ctx.getState(), selectedMasterPlan: undefined });
    }
  }

  @Action(SetMasterPlanPageRefreshFlag)
  setMasterPlanPageRefreshFlag(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SetMasterPlanPageRefreshFlag
  ) {
    ctx.setState({ ...ctx.getState(), refreshMasterPlanGrid: payload });
  }

  @Action(SetMasterPlanRoutePageRefreshFlag)
  setMasterPlanRoutePageRefreshFlag(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SetMasterPlanRoutePageRefreshFlag
  ) {
    ctx.setState({ ...ctx.getState(), refreshRoutes: payload });
  }

@Action(SetMasterPlanLocationGroupPageRefreshFlag)
  setMasterPlanLocationGroupPageRefreshFlag(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SetMasterPlanLocationGroupPageRefreshFlag
  ) {
    ctx.setState({ ...ctx.getState(), refreshLocationGroupInPlans: payload });
  }
  

  @Action(setIsCommittedFlag)
  setIsCommittedFlag(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: setIsCommittedFlag
  ) {
    ctx.setState({ ...ctx.getState(), isPlanCommitted: payload });
  }



  @Action(GetPlanType)
  getPlanType(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: GetPlanType
  ) {
    ctx.setState({ ...ctx.getState(), planType: payload });
  }

  @Action(SetPlanId)
  setPlanId(ctx: StateContext<MasterPlansStateModel>, { payload }: SetPlanId) {
    ctx.setState({ ...ctx.getState(), planId: payload });
  }

  @Action(SelectedDistributionLaneId)
  distributionLaneId(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SelectedDistributionLaneId
  ) {
    if (payload) {
      return ctx.setState({ ...ctx.getState(), distributionLaneId: payload });
    } else {
      return ctx.setState({ ...ctx.getState(), distributionLaneId: undefined });
    }
  }

  @Action(SelectedPlan)
  selectedPlan(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SelectedPlan
  ) {
    if (payload) {
      return ctx.setState({ ...ctx.getState(), selectedPlan: payload });
    } else {
      return ctx.setState({ ...ctx.getState(), selectedPlan: undefined });
    }
  }

  @Action(ClonePlan)
  clonePlan(ctx: StateContext<MasterPlansStateModel>, { payload }: ClonePlan) {
    ctx.setState({ ...ctx.getState(), isPlanCloned: payload });
  }

  @Action(GetPlanLookup)
  getPlansLookup(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: GetPlanLookup
  ) {
    ctx.setState({ ...ctx.getState(), plansLookup: payload });
  }

  @Action(GetScheduler)
  getScheduler(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: GetScheduler
  ) {
    ctx.setState({ ...ctx.getState(), scheduler: payload });
  }

  @Action(SetSignalRResponseOPtimizePlan)
  setSignalRResponseOPtimizePlan(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SetSignalRResponseOPtimizePlan
  ) {
    if (payload) {
      return ctx.setState({ ...ctx.getState(), optimizePlanSignalR: payload });
    } else {
      return ctx.setState({
        ...ctx.getState(),
        optimizePlanSignalR: undefined,
      });
    }
  }

  @Action(GetMasterPlanLookup)
  getMasterPlansLookup(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: GetMasterPlanLookup
  ) {
    ctx.setState({ ...ctx.getState(), masterPlansLookup: payload });
  }

  @Action(SetIsPlanRevision)
  setIsPlanRevision(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: SetIsPlanRevision
  ) {
    ctx.setState({ ...ctx.getState(), isPlanRevision: payload });
  }

  @Action(GetMasterLocations)
  getMasterLocations(
    ctx: StateContext<MasterPlansStateModel>,
    { payload }: GetMasterLocations
  ) {
    ctx.setState({ ...ctx.getState(), masterLocations: payload });
  }

  @Selector()
  static IsPlanCloned(state: MasterPlansStateModel) {
    return state.isPlanCloned;
  }

  @Selector()
  static SelectedPlan(state: MasterPlansStateModel) {
    return state.selectedPlan;
  }

  @Selector()
  static SelectedDistributionLaneId(state: MasterPlansStateModel) {
    return state.distributionLaneId;
  }

  @Selector()
  static AddPlanWithLocation(state: MasterPlansStateModel) {
    return state.planId;
  }

  @Selector()
  static PlanType(state: MasterPlansStateModel) {
    return state.planType;
  }

  @Selector()
  static RefreshMasterPlanGrid(state: MasterPlansStateModel) {
    return state.refreshMasterPlanGrid;
  }

  @Selector()
  static RefreshMasterPlanRoute(state: MasterPlansStateModel) {
    return state.refreshRoutes;
  }

  @Selector()
  static RefreshLocationGroupInPlans(state: MasterPlansStateModel) {
    return state.refreshLocationGroupInPlans;
  }
  

  @Selector()
  static IsPlanCommitted(state: MasterPlansStateModel) {
    return state.isPlanCommitted;
  }

  @Selector([MasterPlansState])
static getSelectedPlanVehicleGroups(state: MasterPlansStateModel){
  return state.vehicleGroups ?? [];
}


  @Selector()
  static MasterPlans(state: MasterPlansStateModel) {
    return state.masterPlans;
  }

  @Selector()
  static Products(state: MasterPlansStateModel) {
    return state.products;
  }

  @Selector()
  static Tags(state: MasterPlansStateModel) {
    return state.tags;
  }
  @Selector()
  static Segments(state: MasterPlansStateModel) {
      return state.Segments;
  }

  @Selector()
  static PostalCode(state: MasterPlansStateModel) {
    return state.postalCode;
  }

  @Selector()
  static SelectedMasterPlan(state: MasterPlansStateModel) {
    return state.selectedMasterPlan;
  }

  @Selector()
  static MasterPlanRequest(state: MasterPlansStateModel) {
    return state.masterPlanRequest;
  }

  @Selector()
  static PlansLookup(state: MasterPlansStateModel) {
    return state.plansLookup;
  }


  @Selector()
  static OptimizePlanSignalR(state: MasterPlansStateModel) {
    return state.optimizePlanSignalR;
  }

  @Selector()
  static MasterPlansLookup(state: MasterPlansStateModel) {
    return state.masterPlansLookup;
  }

  @Selector()
  static IsPlanRevision(state: MasterPlansStateModel) {
    return state.isPlanRevision;
  }

  @Selector()
  static Plans(state: MasterPlansStateModel) {
    return state.plans;
  }

  @Selector()
  static Scheduler(state: MasterPlansStateModel) {
    return state.scheduler;
  }

  @Selector()
  static GetSelectedPlanId(state: MasterPlansStateModel) {
    return state.planId;
  }

  @Selector()
  static GetMasterLocations(state: MasterPlansStateModel) {
    return state.masterLocations;
  }
}
